import { memo, useLayoutEffect } from 'react';

interface PlaywireAdSlotProps {
    className?: string;
    divId: string;
    divIdSufix?: string;
    type: string;
}

const PlaywireAdSlot: React.FC<PlaywireAdSlotProps> = props => {
    const { type, divId, divIdSufix = '', className } = props;

    const selectorId = divIdSufix ? `${divId}-${divIdSufix}` : divId;

    const addAd = () => {
        if (!window.ramp) return;
        const payload = {
                ads: [{ selectorId, type }],
                path: location.pathname,
                countPageView: false,
        };
        window.ramp.que?.push(() => {
            console.log('[PlaywireAdSlot] spaAds:', payload);
            window.ramp.spaAds(payload);
        }); 
    };

    useLayoutEffect(() => {
        addAd();
    }, [selectorId]);

    return <div className={className} id={selectorId} />;
};

export default memo(PlaywireAdSlot);
